module.exports = __webpack_public_path__ + "img/T5-C-xh7.60daa19b.png";